"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeDeploymentsL1ChainIds = exports.safeDeploymentsVersions = exports.SAFE_BASE_VERSION = exports.SAFE_LAST_VERSION = void 0;
exports.SAFE_LAST_VERSION = '1.3.0';
exports.SAFE_BASE_VERSION = '1.1.1';
exports.safeDeploymentsVersions = {
    '1.3.0': {
        safeMasterCopyVersion: '1.3.0',
        safeMasterCopyL2Version: '1.3.0',
        safeProxyFactoryVersion: '1.3.0',
        multiSendVersion: '1.3.0'
    },
    '1.2.0': {
        safeMasterCopyVersion: '1.2.0',
        safeMasterCopyL2Version: undefined,
        safeProxyFactoryVersion: '1.1.1',
        multiSendVersion: '1.1.1'
    },
    '1.1.1': {
        safeMasterCopyVersion: '1.1.1',
        safeMasterCopyL2Version: undefined,
        safeProxyFactoryVersion: '1.1.1',
        multiSendVersion: '1.1.1'
    }
};
exports.safeDeploymentsL1ChainIds = [
    1 // Ethereum Mainnet
];
//# sourceMappingURL=config.js.map